import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OktaService from '../../../../services/okta-service';
import { logoutUser } from './logout.action';
import { resetBaseData } from '../../app.action';

const Logout: ReactComponent = (props: ReactComponentProps): null => {
  const {
    oktaAuth,
    authState: oktaAuthState,
  } = props;

  const dispatch: ReduxDispatch = useDispatch();
  const currentUser: User = useSelector(({ app }: Reducers): User => app.baseData && app.baseData.currentUser);

  const isOktaAuthenticated: boolean = OktaService.checkIsOktaAuthenticated(oktaAuthState);

  useEffect((): void => {
    if (currentUser) {
      if (isOktaAuthenticated) {
        (async (): Promise<void> => {
          await OktaService.oktaLogout(oktaAuth);
        })();
      }

      dispatch(resetBaseData());
      dispatch(logoutUser());
    }
  }, [currentUser]);

  return null;
};

export default OktaService.withOktaAuth(Logout);
